import { AxiosError } from 'axios'
import {
    UseInfiniteQueryOptions,
    UseQueryOptions,
    // InvalidateQueryFilters,
    // InvalidateOptions,
    // useQueryClient,
    useQuery,
    // useInfiniteQuery,
    useMutation,
} from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import {
    TNetworkServiceError,
    TSubscribeProps,
    TSubscribeResponse,
    TSubscribeUserProps,
    TSubscribeUserResponse,
    TUnsubscribeUserProps,
    TUnsubscribeUserResponse,
} from 'services/NetworkService'
import { QueryCacheKeys } from 'enums'
import { NetworkService } from 'services'
import * as userSelectors from 'containers/User/user-selectors'
import { getRequestError } from 'utils/helpers'

export type TFetchFnParams = TSubscribeProps
export type TFetchFnResponse = TSubscribeResponse
export type TFetchFnError = AxiosError<TNetworkServiceError, TFetchFnParams>
export type TError = [string, TFetchFnError]
export type TQueryKey = [string, TFetchFnParams]
export type TQueryFnOpts = UseQueryOptions<TFetchFnResponse, TError, TFetchFnResponse, TQueryKey>
export type TInfiniteQueryFnOpts = UseInfiniteQueryOptions<
    TFetchFnResponse,
    TError,
    TFetchFnResponse,
    TFetchFnResponse,
    TQueryKey
>

export type TSubscribeUserMutationFnError = [string, AxiosError<TNetworkServiceError, TSubscribeUserProps>]
export type TUnsubscribeUserMutationFnError = [string, AxiosError<TNetworkServiceError, TUnsubscribeUserProps>]

const key = QueryCacheKeys.subscribe

/**
 * Хук API получить список подписок
 */
export default function useFetchSubscribe(params: TFetchFnParams, opts: TQueryFnOpts = {}) {
    const { t } = useTranslation()
    const user = useSelector(userSelectors.user)

    return useQuery([`${key}-${user.id}`, params], () => {
        return NetworkService.fetchSubscribe(params)
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject([getRequestError(err) || t('update_error'), err])
            })
    }, opts)
}

export function useMutationSubscribe() {
    const { t } = useTranslation()

    const subscribeUser = useMutation<
        TSubscribeUserResponse,
        TSubscribeUserMutationFnError,
        TSubscribeUserProps,
        unknown
    >((props) => {
        return NetworkService.subscribeUser(props)
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject([getRequestError(err) || t('update_error'), err])
            })
    })

    const unsubscribeUser = useMutation<
        TUnsubscribeUserResponse,
        TUnsubscribeUserMutationFnError,
        TUnsubscribeUserProps,
        unknown
    >((props) => {
        return NetworkService.unsubscribeUser(props)
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject([getRequestError(err) || t('update_error'), err])
            })
    })

    return {
        subscribeUser,
        unsubscribeUser,
    }
}
